export const Number_List = `
<h3>Number List</h3>
<hr />
<article id="number-list">
  <div class="row">
    <div class="col-lg-3 d-none d-lg-block"></div>
    <div class="col-lg-7 col-md-12">
      <div class="intro-copy">
        In this module, you’ll learn how to:
      </div>
      <ol>
        <li id="number-listitem1">Recognize what helps build up your confidence</li>
        <li id="number-listitem2">Understand what knocks down your confidence</li>
        <li id="number-listitem3">Manage your confidence</li>
        <li id="number-listitem4">Implement strategies to boost your confidence</li>
        <li id="number-listitem5"></li>
        <li id="number-listitem6"></li>
        <li id="number-listitem7"></li>
        <li id="number-listitem8"></li>
        <li id="number-listitem9"></li>
        <li id="number-listitem10"></li>
      </ol>
      <div class="intro-copy">

      </div>
      <div class="col-lg-2 d-none d-lg-block"></div>
    </div>
  </div>
</article>
`;
